import { useState } from "react";
import { LOGIN, LOGIN_INVALID_CREDENTIALS } from "../data/data";
import { login } from "../services/services";
import useAuth from "./useAuth";
import useNavigateTo from "./useNavigateTo";
const useLogin = () => {
    let navigateTo = useNavigateTo();

    const auth = useAuth();

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({ error: false, name: "" });

    const loginUser = (cuit, password) => {
        setIsLoading(true);
        setError({ ...error, error: false });
        login(cuit, password)
            .then((json) => {
                if (json?.data?.token) {
                    auth.login(json.data.token);
                    navigateTo("/");
                } else {
                    setError({
                        ...error,
                        error: true,
                        name: LOGIN_INVALID_CREDENTIALS,
                    });
                }
            })
            .catch((error) => {
				console.log("error", error)
                setError({
                    ...error,
                    error: true,
                    name: LOGIN,
                });
            })
            .finally(() => setIsLoading(false));
    };

    return {
        isLoading,
        error,
        loginUser,
    };
};
export default useLogin;
